import React, {useContext, useEffect, useState} from 'react'
import Option from 'app/React/Components/Form/Option'
import Tip from 'app/React/Components/misc/Tip'
import getOptionPriceDescription from "app/React/Helpers/getOptionPriceDescription";
import {ConfiguratorContext} from "app/React/ConfiguratorContainer";

export default function SpecificVariantSetting(props) {
  const {
    car,
    currentModelYear,
    dealerNumberOptions,
    isDealerConfigurator,
    lang,
    order,
    setOrder,
    strings,
    showCampaignPrice,
    showModelYearOnVariants,
    getVariantsFromModelYears,
    showAsOrdinaryDealer,
  } = useContext(ConfiguratorContext)

  const description = car.variant_setting_description ?? ''
  const subDescription = car['variant_setting_title_sub_description_' + order.paymentType] ?? ''

  const [modelYearVariants, setModelYearVariants] = useState([])

  const [checked, setChecked] = useState(
    typeof order.configuration?.variants === 'object' ? order.configuration.variants.id : null
  )

  useEffect(() => {
    setChecked(typeof order.configuration?.variants === 'object' ? order.configuration?.variants.id : null)
  }, [order])

  useEffect(() => {
    let _variants = getVariantsFromModelYears(false, order.dealer_number ?? null)

    if (isDealerConfigurator && _variants.length < 1) {
      for (const dealerNumberOption of dealerNumberOptions) {
        if (order.dealer_number == dealerNumberOption.value) {
          continue
        }

        const dealerNumber = dealerNumberOption.value
        const filteredVariants = getVariantsFromModelYears(false, dealerNumber)

        if (filteredVariants.length < 1) {
          continue
        }

        _variants = filteredVariants
        setOrder({ ...order, dealer_number: dealerNumber })

        break
      }
    }

    const currentVariantInVariants = _variants.some(x => x.id == order.configuration.variants.id)

    if (!currentVariantInVariants) {
      setChecked(_variants[0].id)
      props.onChange(null, _variants[0])
    }

    setModelYearVariants(_variants)
  }, [currentModelYear, showAsOrdinaryDealer])
  console.log(modelYearVariants);
  if (modelYearVariants.length < 1) {
    return null
  }

  const option_elements = modelYearVariants.map((variant, index) => {
    return (
      <Option
        key={index}
        option={{
          ...variant,
          description_override: getOptionPriceDescription(
            variant,
            checked,
            modelYearVariants,
            showCampaignPrice,
            isDealerConfigurator,
            lang,
            order,
            strings
          ),
          top_description: showModelYearOnVariants ? variant.model_year : ''
        }}
        layout='standard'
        settingid='variants'
        onChange={props.onChange}
        checked={checked}
        setChecked={setChecked}
        required
        hidePrice={true}
      />
    )
  })

  return (
    <>
      <div className='setting variant-setting' data-setting-id='variants'>
        <h3 className='config-subtitle'>
          {strings.form.choose_variant}
          {typeof description === 'string' && description.length > 0 ? (
            <Tip button='Ok' content={description}/>
          ) : null}
        </h3>
        {
          typeof subDescription === 'string' && subDescription.length > 0 && (
            <div className='config-variant-subtitle' dangerouslySetInnerHTML={{ __html: subDescription }}/>
          )
        }
        <div className='config-radio' data-option-count={option_elements.length}>
          {option_elements}
        </div>
      </div>
      <div className='config-seperator'/>
    </>
  )
}

SpecificVariantSetting.defaultProps = {
  onChange: null,
  className: '',
  hidePrice: false
}
